import Vue from 'vue';
import VueMaterial from 'vue-material';

Vue.use(VueMaterial);

class API {
	static get host() {
		return 'http://138.197.182.77:8081';
	}

	static get match() {
		return `${this.host}/api/match`;
	}
}
 
($ => { $(() => {

	const TakeAPicture = new Vue({
		el: '.take-a-picture',
		data: {
			uploadStarted: false,
			uploadEnded: false,
			progress: 0,
			file: {}
		},
		computed: {
			showSpinner () {
				return this.uploadStarted && this.uploadEnded;
			},
			showProgress () {
				return this.uploadStarted && !this.uploadEnded;
			}
		},
		methods: {
			triggerUpload: function(e) {
				$(this.$refs.file).trigger('click');
			},
			onImageChange: function(e) {
				const file = e.target.files[0];
				this.file = file;
				
				const data = new FormData();
				data.append('file', file);
				
				$.ajax({
					url: API.match,
					type: 'POST',
					crossDomain: true,
					contentType: false,
					processData: false,
					data: data,
					xhr: () => {
						var xhr = new window.XMLHttpRequest();
						//Upload progress
						xhr.upload.addEventListener("progress", (evt) => {
							if (evt.lengthComputable) {
								var percent = evt.loaded / evt.total;
								var percentComplete = 100 * evt.loaded / evt.total;
								//Do something with upload progress

								this.onProgress(percentComplete);
								if (percent === 1) {
									this.uploadEnded = true;
								}
							}
						}, false);
						
						//Download progress
						xhr.addEventListener("progress", function(evt){
							if (evt.lengthComputable) {
								var percentComplete = 100 * evt.loaded / evt.total;
								//Do something with download progress
								console.log(`download: ${percentComplete}`);
							}
						}, false);
						return xhr;
					},
					beforeSend: () => {
						this.startProgress();
					},
					success: (data) => {
						this.Image = data;
						this.redirectoToURL(data.image.url);
					}
				});
			},
			startProgress: function() {
				console.log('start ajax call');
				this.uploadStarted = true;
			},
			onProgress(percentComplete) {
				console.log(`upload: ${percentComplete}`);
				this.progress = percentComplete;
			},
			redirectoToURL: (url) => {
				window.location.href = url;
			}
		}
	})

}) })(jQuery)



// WEBPACK FOOTER //
// ./src/js/take-a-picture.jsx